var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurebarre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.3594 28.0898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.0898,
    opacity: 0,
    width: 28.3594,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7773 5.36719C13.1836 5.36719 14.3203 4.23047 14.3203 2.8125C14.3203 1.40625 13.1836 0.269531 11.7773 0.269531C10.3477 0.269531 9.21094 1.40625 9.21094 2.8125C9.21094 4.23047 10.3477 5.36719 11.7773 5.36719ZM12.5508 16.3711L18.9961 18.3633L25.1602 21.1641C26.7539 21.8789 27.6914 19.6406 26.1914 18.9492L15.5742 14.1562L15.5742 8.46094C15.5742 7.99219 15.6914 7.93359 16.0312 7.80469L19.2305 6.50391C19.6289 6.33984 19.6641 6.24609 19.8633 6.01172L23.2266 2.10938C23.6719 1.59375 23.5898 0.832031 23.0859 0.410156C22.582-0.0234375 21.8086 0.046875 21.3867 0.550781L18.1758 4.28906L3.39844 10.3242C2.97656 10.4883 2.70703 10.6641 2.53125 10.8398L8.55469 10.8398L10.3711 10.1133C10.7344 9.97266 10.8633 10.1016 10.8633 10.3242L10.8633 14.0508C10.8633 15.2812 11.4258 16.0312 12.5508 16.3711ZM11.4844 26.5898C11.2148 27.5156 11.9531 28.0898 12.668 28.0898C13.1602 28.0898 13.6641 27.8203 13.8164 27.2227L15.5391 20.9883C15.5625 20.8711 15.5742 20.7539 15.5742 20.6602L15.5742 18.457L12.7734 17.6016L13.1367 20.5898ZM0.65625 13.3125L9.70312 13.3125L9.70312 12.0117L0.65625 12.0117C0.28125 12.0117 0 12.293 0 12.6562C0 13.0195 0.28125 13.3125 0.65625 13.3125ZM27.3633 13.3125C27.7266 13.3125 28.0078 13.0195 28.0078 12.6562C28.0078 12.293 27.7266 12.0117 27.3633 12.0117L16.7461 12.0117L16.7461 12.8906L16.7461 13.3125Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurebarre);
export default __webpack_public_path__ + "static/media/figure.barre.96c86a80e67778dd9b870551363627c0.svg";
export { ForwardRef as ReactComponent };